import { allotmentService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    form_data: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.fetchUserStatus = 'loading'
    },
    success(state, form_data) {
        state.status   = 'success'
        state.form_data = form_data
    },
    successFetchUserShebas(state, user_shebas) {
        state.fetchUserStatus = 'success'
        state.userShebas = user_shebas
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    user_shebas: ({userShebas}) => userShebas,
    fetch_user_status: ({fetchUserStatus}) => fetchUserStatus
}

const actions = {
    // find({commit}, hashid) {
    //     commit('loading')
    //     return allotmentService.find(hashid).then(response => {
    //         console.log(response.data.data)
    //         commit('success', response.data.data)
    //     })
    // },
    find({commit}, data) {
        commit('success', data)
    },
    fetchUserShebas({commit}, params) {
        console.log(params)
        commit('successFetchUserShebas', params)
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}